import React, { useState, useEffect, useCallback } from "react";
import { Grid, TextField, Button, Box } from "@mui/material";
import _ from "lodash";
import * as actions from "./actions";
import CustomShowModal from "../Common/customShowModal";
import { toastError, toastSuccess } from "../../utils";

export default function UserActions(props) {
  const [createUserData, setCreateUserData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
  });

  const [openAddUser, setOpenAddUser] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCreateUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCreateUser = () => {
    if (
      !(
        createUserData.name &&
        createUserData.email &&
        createUserData.phone &&
        createUserData.address &&
        createUserData.password
      )
    ) {
      toastError("All fields are required");
      return;
    }
    props.setLoader(true);
    actions
      .addUserAndAssignToSubAdmin({
        name: createUserData.name,
        email: createUserData.email,
        phone: createUserData.phone,
        address: createUserData.address,
        password: createUserData.password,
      })
      .then((res) => {
        setOpenAddUser(false);
        setCreateUserData({
          name: "",
          email: "",
          phone: "",
          address: "",
          password: "",
        });
        props.setLoader(false);
        toastSuccess(res.message || "Created successfully");
      })
      .catch((err) => {
        props.setLoader(false);
        toastError("Email already assigned");
      });
  };

  return (
    <>
      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={() => setOpenAddUser(true)}
          >
            Create User
          </Button>
        </div>
      </Grid>

      <CustomShowModal
        handleClose={() => setOpenAddUser(false)}
        title={"Add User Details"}
        open={openAddUser}
        maxWidth="sm"
      >
        <>
          <div style={{ textAlign: "center" }}>
            <Box mt={1}>
              <TextField
                label="User Name"
                name="name"
                variant="outlined"
                size="small"
                value={createUserData.name}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="User Email"
                name="email"
                type="email"
                variant="outlined"
                size="small"
                value={createUserData.email}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="Phone Number"
                name="phone"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.phone}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="User Address"
                name="address"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.address}
                onChange={handleChange}
                fullWidth
              />
            </Box>
            <Box mt={1}>
              <TextField
                label="Password"
                name="password"
                type="text"
                variant="outlined"
                size="small"
                value={createUserData.password}
                onChange={handleChange}
                fullWidth
              />
            </Box>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button color="primary" variant="contained" onClick={onCreateUser}>
              Create User
            </Button>
          </div>
        </>
      </CustomShowModal>
    </>
  );
}
